var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "video",
      style: "background-image: url(" + _vm.cover + ");"
    },
    [
      _vm.youtubeUrl
        ? _c("iframe", {
            staticClass: "video__player",
            attrs: {
              src:
                "https://www.youtube-nocookie.com/embed/" +
                _vm.youtubeUrl +
                "?rel=0&showinfo=0",
              frameborder: "0",
              allow: "autoplay; encrypted-media",
              allowfullscreen: ""
            }
          })
        : _vm._e(),
      _vm.videoUrl
        ? _c("video", {
            staticClass: "video__player",
            attrs: { src: _vm.videoUrl, controls: "" }
          })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bba2a3a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bba2a3a8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/articles/ArticleVideo.vue
// module id = nYlM
// module chunks = 0 1 2 3 4 5 7 8 9 15 28